<template>
  <v-card class="px-5">
    <v-card-title>
      <div class="card-title-title">
        도큐먼트 정보 개선하기
      </div>
      <div class="card-title-docinfo">
        <span>{{ existing_doc.authors_iso690 }}</span>
        <span>({{ existing_doc.date }})</span>
        <span><strong>{{ existing_doc.title }}</strong></span>
      </div>
    </v-card-title>

    <v-card-text>
      <!-- Exist values -->
      <div v-if="!!exist_values.length">
        <div class="row-title">
          {{ $t('improve_doc_info.existing_columns')}}
          <v-btn x-small icon @click="is_opened=!is_opened">
            <v-icon v-if="is_opened">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </div>
        <div class="row" v-if="is_opened"
          v-for="(val, index) in exist_values" :key="index">
          <div class="column-name">{{ $t('input_form.'+ val.key ) }}</div>
          <!-- People -->
          <div v-if="people.includes(val.key)" class="label-text">
            <span v-for="(p, i) in val.value" :key="i">
              <span>{{ p.lastname }}</span>
              <span v-if="!!p.firstname">, {{ p.firstname }}</span>
              <span v-if="!!p.name_id">({{ p.name_id }})</span>
            </span>
          </div>
          <div class="label-text" v-else>{{ val.value }}</div>
        </div>
      </div>

      <!-- New values -->
      <div v-if="!!new_values.length">
        <div class="row-title">
          {{ $t('improve_doc_info.new_columns')}}
        </div>
        <div v-for="(val, index) in new_values" class="row" :key="index">
          <div class="column-name">{{ $t('input_form.'+ val.key ) }}</div>
          <!-- People -->
          <div v-if="people.includes(val.key)">
            <v-checkbox
              v-model="val.update">
              <template v-slot:label>
                <span v-for="(p, i) in val.value" :key="i">
                  <span>{{ p.lastname }}</span>
                  <span v-if="!!p.firstname">, {{ p.firstname }}</span>
                  <span v-if="!!p.name_id">({{ p.name_id }})</span>
                </span>
              </template>
            </v-checkbox>
          </div>
          <div v-else>
            <v-checkbox
              v-model="val.update"
              :label="val.value">
            </v-checkbox>
          </div>
        </div>
      </div>

      <!-- Compare values -->
      <div v-if="!!compare_values.length">
        <div class="row-title">
          {{ $t('improve_doc_info.compare_columns')}}
        </div>
        <div v-for="(val, index) in compare_values" class="row" :key="index">
          <div class="column-name">{{ $t('input_form.'+ val.key ) }}</div>
          <!-- People -->
          <div v-if="people.includes(val.key)">
            <v-radio-group v-model="val.value">
              <v-radio v-for="(m, i) in val.model" class ="radio"
                :key="i"
                :value="m">
                <template v-slot:label>
                  <span>
                    <span class="highlight">{{ i + 1 }}</span>
                    <span v-for="(p, j) in m" :key="j">
                      <span>{{ p.lastname }}</span>
                      <span v-if="!!p.firstname">, {{ p.firstname }}</span>
                      <span v-if="!!p.name_id">({{ p.name_id }})</span>
                      <span v-if="j<m.length">;&nbsp;</span>
                    </span>
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
          <!-- Else -->
          <div v-else>
            <v-radio-group v-model="val.value">
              <v-radio v-for="(m, i) in val.model" class ="radio"
                :key="i"
                :value="m">
                <template v-slot:label>
                  <span>
                    <span class="highlight">{{ i + 1 }}</span>
                    <span v-if="val.key=='lang'">{{ language_model[m].name }}</span>
                    <span v-else>{{ m }}</span>
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="footer">
      <div class="message-error" v-if="error">
        {{ error_message }}
      </div>
      <div class="buttons">
        <v-btn small depressed @click="cancel()">
          {{ $t('actions.cancel')}}
        </v-btn>
        <v-btn small depressed color="primary"
          @click="confirm()">
          {{ $t('actions.confirm')}}
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { returnDocDetail, deleteEmptyFields, deleteEmptyCols } from '../../../custom/function'
import { doc_types, people_types, institutions, column_names, languages } from '../../../custom/model'

export default {
  props: {
    opened: {
      type: Boolean,
    },

    compares: {
      type: Array,
    },

    result: {
      type: String,
    },
  },

  data() {
    return {
      doc_type_model: doc_types,
      people_type_model: people_types,
      institutions: institutions,
      column_name_model: column_names,
      language_model: languages,

      is_opened: false,

      keys: [],
      index: 0,
      raw_existing_doc: {},
      existing_doc: {},
      
      exist_values: [],
      new_values: [],
      compare_values: [],

      error: false,
      error_message: "",
    }
  },

  computed: {
    people() {
      return Object.keys(this.people_type_model)
    },
  },

  watch: {
    compares: {
      handler(val) {
        if (!!val.length) {
          this.keys = val.map(v => v.key)
          this.setData()
        }
      },
      deep: true,
      immediate: true,
    },

    index: {
      handler(val) {
        this.setData()
      },
    },
  },

  methods: {
    returnDocDetail,
    deleteEmptyFields,
    deleteEmptyCols,

    initiate() {
      this.is_opened = false

      this.keys = []
      this.index = 0
      this.raw_existing_doc = {}
      this.existing_doc = {}

      this.exist_values = []
      this.new_values = []
      this.compare_values = []

      this.error = false
      this.error_message = ""
    },

    async getDocument(key) {
      let error = false
      let doc = null
      try {
        await this.$store.dispatch('input/getNewDocument', key)
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
      } finally {
        if (!error) {
          doc = this.$store.getters['input/new_document']
        }
        return doc
      }
    },

    async setData() {
      let compare_keys = []
      let compare_docs = []
      try {

        // Get compare docs
        compare_keys = this.compares[this.index].compare_keys
        for (let i=0; i<compare_keys.length; i++) {
          let compare_doc = await this.getDocument(compare_keys[i])
          compare_docs.push(compare_doc)
        }

        // Get existing doc
        this.raw_existing_doc = compare_docs[0]
        this.existing_doc = 
          this.returnDocDetail(this.raw_existing_doc, this.raw_existing_doc.doc_type)

        // Get user doc
        let user_doc = this.compares[this.index]['user_doc']['document']
        compare_docs.push(user_doc)
        // console.log('compare_docs', compare_docs)

      } finally {

        // Get compare columns by doc_type
        let columns = this.doc_type_model[this.existing_doc.doc_type].compare_columns

        // Compare values
        for (let i=0; i<columns.length; i++) {
          let key = columns[i]
          let values = compare_docs.map(v => v[key])
          this.compareValues(key, values, compare_docs[0][key])
        }
      }
    },

    comparePeople(arr, com_arr) {
      let is_same = true
      if (arr.length == com_arr.length) {
        for (let i=0; i<arr.length; i++) {
          if (!!arr[i].name_id) {
            // console.log(arr[i].name_id, com_arr[i].name_id)
            is_same = is_same
              && arr[i].name_id == com_arr[i].name_id
          } else if (!!arr[i].lastname) {
            // console.log(arr[i].lastname, com_arr[i].lastname)
            is_same = is_same
              && arr[i].lastname == com_arr[i].lastname
              && arr[i].firstname == com_arr[i].firstname
          } else {
            is_same = false
          }
        }
      } else {
        is_same = false
      }
      // console.log('is_same', is_same)
      return is_same
    },

    compareValues(key, values, existing_value) {
      let n_values = []

      // People: lastname, firstname, name_id 비교
      if (this.people.includes(key)) {

        // Delete empty arrays
        n_values = values.filter(v => !!v &&
          (Array.isArray(v) && !!v.length))

        if (!!n_values.length) {
          let n_values_ext = [n_values[0]]
          // console.log(n_values)
          for (let i=1; i<n_values.length; i++) {
            let com_arr = n_values[i]
            var is_same = false
            for (let j=0; j<n_values_ext.length; j++) {
              let ext_arr = n_values_ext[j]
              is_same = is_same || this.comparePeople(ext_arr, com_arr)
            }
            if (!is_same) { n_values_ext.push(com_arr) }
          }

          if (n_values_ext.length == 1) {
            if (!existing_value || 
              (Array.isArray(existing_value) && !existing_value.length)) {
              this.new_values.push({
                key: key,
                name: this.column_name_model[key].name,
                value: n_values_ext[0],
                update: true,
              })
            } else {
              this.exist_values.push({
                key: key,
                name: this.column_name_model[key].name,
                value: n_values[0],
              })
            }
          }
          else if (n_values_ext.length > 1) {
            this.compare_values.push({
              key: key,
              name: this.column_name_model[key].name,
              model: n_values_ext,
              value: n_values_ext[0],
            })
          }
        }
      }

      // Else
      else {
        // Delete empty values
        n_values = values.filter(v => !!v)

        if (this.institutions.includes(key)) {
          n_values = (values.filter(v => !!v)).map(v => 
            typeof(v)==='object' ? v.name : v)
        }

        // Delete duplicates
        n_values = Array.from(new Set(n_values))

        // Compare
        if (n_values.length>1) {
          this.compare_values.push({
            key: key,
            name: this.column_name_model[key].name,
            model: n_values,
            value: n_values[0],
          })
        }

        // New
        else if (n_values.length==1&&n_values[0]!=existing_value) {
          this.new_values.push({
            key: key,
            name: this.column_name_model[key].name,
            value: n_values[0],
            update: true,
          })
        }

        // Exist
        else if (n_values.length==1) {
          this.exist_values.push({
            key: key,
            name: this.column_name_model[key].name,
            value: n_values[0],
          })
        }
      }
    },

    cancel() {
      this.$emit('update:opened', false)
    },

    async confirm() {
      let docs_input = this.createDocsInput()
      this.$analytics.logEvent('click', { name: 'improveDocInfo_btn_confirm' })
      // console.log('docs_input', docs_input)

      if (!!docs_input) {
        try {
          await this.$store.dispatch('input/inputDocuments', docs_input)
        } catch(e) {
          this.error = true
          this.error_message = "An error has occured inputting documents(" + error_code + ")"
        } finally {
          if (!this.error) {
            try {
              this.compares.shift()
              this.$emit('update:compares', this.compares)
              this.$emit('update:result', this.existing_doc.key)
            } finally {
              this.initiate()
              if (!this.compares.length) {
                this.cancel()
              }
            }
          }
        }
      } else {
        this.compares.shift()
        this.$emit('update:compares', this.compares)
        this.$emit('update:result', this.existing_doc.key)
        if (!this.compares.length) {
          this.cancel()
        }
      }
    },

    createDocsInput() {
      let docs_input = {}
      let vm = this

      let source = this.compares[this.index]['user_doc']['source']
      let document = this.deleteEmptyFields(JSON.parse(JSON.stringify(this.raw_existing_doc)))
      document['doc_key'] = document['key']

      function reviseDocument(values) {
        for (let i=0; i<values.length; i++) {
          // People
          if (vm.people.includes(values[i]['key'])) {
            let n_values = []
            for (let j=0; j<values[i]['value'].length; j++) {
              let value_ext = values[i]['value'][j]
              if (Object.keys(value_ext).includes('name_id')) {
                n_values.push({
                  ordinal_num: j+1,
                  name_id: value_ext['name_id'],
                })
              } else {
                n_values.push({
                  ordinal_num: j+1,
                  lastname: value_ext['lastname'],
                  firstname:value_ext['firstname'],
                })
              }
            }
            values[i]['value'] = n_values
          }
          document[values[i]['key']] = values[i]['value']
        }
      }

      // New values
      if (!!this.new_values.length) {
        let values = this.new_values.filter(v => !!v.update)
        if (!!values.length) { reviseDocument(values) }
      }

      // Compare values
      if (!!this.compare_values.length) {
        reviseDocument(this.compare_values)
      }

      if (!!this.new_values.length || !!this.compare_values.length) {
        docs_input['docs_update'] = [{ source, document }]
        return docs_input
      } else { return null }
    }
  },
}
</script>

<style scoped>

  .card-title-title {
    font-size: 1.25rem;
    letter-spacing: -.25px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .card-title-docinfo {
    font-size: 14px !important;
    line-height: 20px;
    word-break: keep-all;
  }

  .column-name {
    margin-right: 12px;
  }

  .label-text {
    font-size: 12px;
  }

  .footer {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .footer > div {
    margin: 10px 0;
    width: 100%;
  }

  .footer > .buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .footer .v-btn {
    margin-left: 12px;
  }

  .row-title {
    font-weight: 500;
    color: #2c3e50;
    margin-top: 16px;
    margin-bottom: 5px;
  }

  .row {
    display: grid;
    grid-template-columns: 100px auto;
    padding: 5px 16px;
  }

  .radio {
    display: flex;
    align-items: flex-start;
  }

  .highlight {
    color: #2c3e50;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared_components/whole/ImproveDocInfo.vue